import React, { useState } from "react";
import { get } from "lodash";
import Vendor from "./Vendor";
import useTitle from "../element/useTitle";
import { VendorsApi } from "../api/Vendors";
import { checkForm } from "../element/Utils";
import { navigate } from "@reach/router";

function VendorCont(props) {
  const [host] = useState(window.location.hostname);
  const isMondiale = host.includes("mondiale");
  const isMMEA = host.includes("mmea");
  const isClearFog = host.includes("clearfog");
  const isSouter = host.includes("souter");

  const formRef = React.createRef();
  const [submitting, setSubmitting] = useState(false);

  useTitle("Vendor Registration Form");

  const payload = {
    realm: "RMA Africa"
  };

  async function submit() {
    let newObject = await checkForm(formRef);
    let data = { ...newObject, ...payload };

    if (get(data, "accounts.isSameAsRep"))
      data.accounts = { ...data.accounts, ...data.representativeContact };

    if (get(data, "coordinator.isSameAsRep"))
      data.coordinator = { ...data.coordinator, ...data.representativeContact };

    setSubmitting(true);
    try {
      const submitted = await VendorsApi.create(data);
      if (submitted) navigate("/Success");
    } catch (e) {
      console.log(e);
    }
    setSubmitting(false);
  }

  return (
    <Vendor
      {...{
        submit,
        submitting,
        host,
        isMondiale,
        isMMEA,
        isClearFog,
        isSouter
      }}
      ref={formRef}
    />
  );
}

export default VendorCont;
